import { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

export default function HomeNavbarCategory() {
	const navigate = useNavigate();
	const tabsBoxRef = useRef(null);
	const [scrollLeft, setScrollLeft] = useState(0);

	const handleSubCategorySelect = (subCatId) => {
		navigate(`/category/${subCatId}`);
	};

	const subCategoriesData = [
		{
			id: 1,
			title: "Players",
			sub_categories: [
				{ id: 1, title: "Umatics" },
				{ id: 2, title: "BETACAM Sp" },
				{ id: 3, title: "BetaCAM" },
				{ id: 4, title: "Mini DV DVCAM" },
				{ id: 5, title: "DigiBeta" },
				{ id: 6, title: "HD CAM" },
				{ id: 7, title: "Betamax" },
				{ id: 8, title: "DVCAM" },
				{ id: 9, title: "D2" },
				{ id: 10, title: "D1" },
				{ id: 11, title: "D5" },
				{ id: 12, title: "svhs" },
				{ id: 13, title: "DVC" },
				{ id: 14, title: "Tape Recorder" },
				{ id: 15, title: "VHS SVHS" },
				{ id: 16, title: "DVCPRO" },
				{ id: 17, title: "VTR or VCR Recorder, Player" },
				{ id: 18, title: "Players" },
			],
		},
		{
			id: 2,
			title: "Miscellaneous",
			sub_categories: [
				{ id: 1, title: "1 Inch" },
				{ id: 4, title: "Digital Instrumentation" },
				{ id: 5, title: "Film" },
				{ id: 6, title: "2 Inch" },
				{ id: 7, title: "1 inch Type B" },
				{ id: 8, title: "HDCAM" },
				{ id: 9, title: "Frame Synchronizer" },
				{ id: 10, title: "TBC" },
				{ id: 11, title: "FILM" },
				{ id: 12, title: "HDCAM SR" },
				{ id: 13, title: "2 INCH QUAD" },
				{ id: 14, title: "DAS" },
				{ id: 15, title: "Pal" },
				{ id: 16, title: "Capacitor and Inductor Analyzer" },
				{ id: 17, title: "Systems Integrated" },
				{ id: 18, title: "PAL Equipment" },
				{ id: 19, title: "Racks, Consoles" },
				{ id: 20, title: "Models to be categorized" },
				{ id: 21, title: "HD Cinema" },
				{ id: 22, title: "4K XDCAM" },
				{ id: 23, title: "new Adaptor" },
				{ id: 24, title: "new Transmitter" },
				{ id: 25, title: "new Archiving" },
				{ id: 26, title: "new Accessories" },
			],
		},
		{
			id: 3,
			title: "Cameras",
			sub_categories: [
				{ id: 1, title: "Camera Tripod" },
				{ id: 2, title: "View-inders" },
				{ id: 3, title: "3CCD Cameras" },
				{ id: 4, title: "Camera Accessories" },
				{ id: 5, title: "Camcorders" },
				{ id: 6, title: "Camera Support" },
				{ id: 7, title: "Cameras XDCAM" },
				{ id: 8, title: "4K HDR CAMCORDER" },
				{ id: 9, title: "Camera Remote Control Panel" },
				{ id: 10, title: "new PTZ Cameras" },
				{ id: 11, title: "new PTZ Camera Contr" },
				{ id: 12, title: "new Camcorder" },
				{ id: 13, title: "new Digital Camera" },
				{ id: 14, title: "new Camera Kit" },
				{ id: 15, title: "Television Studio & EFP Cameras" },
				{ id: 16, title: "new Projectors" },
				{ id: 17, title: "Digital Cinema Camer" },
			],
		},
		{
			id: 4,
			title: "Displays",
			sub_categories: [
				{ id: 1, title: "Monitor" },
				{ id: 2, title: "Waveform Monitor" },
				{ id: 3, title: "Monitors" },
				{ id: 4, title: "Color Monitor" },
				{ id: 5, title: "Monitors & Displays" },
			],
		},
		{
			id: 5,
			title: "Service",
			sub_categories: [{ id: 1, title: "Tape Cleaners" }],
		},
		{
			id: 6,
			title: "Video Production",
			sub_categories: [
				{ id: 1, title: "Remote control panel" },
				{ id: 2, title: "Video Editing & Production" },
			],
		},
		{
			id: 7,
			title: "Optics Lenses",
			sub_categories: [
				{ id: 1, title: "Lens's" },
				{ id: 2, title: "Lenses" },
				{ id: 3, title: "Optics Lenses" },
			],
		},
		{
			id: 8,
			title: "Pro Audio",
			sub_categories: [
				{ id: 1, title: "Audio" },
				{ id: 2, title: "Pro Audio" },
				{ id: 3, title: "new Audio" },
				{ id: 4, title: "new Microphone" },
			],
		},
		{
			id: 9,
			title: "Camera Support",
			sub_categories: [
				{ id: 1, title: "Fluid Head" },
				{ id: 2, title: "Tripods" },
				{ id: 3, title: "Tripods Head" },
			],
		},
		{
			id: 10,
			title: "Signal & Transmission",
			sub_categories: [
				{ id: 1, title: "Transmitter" },
				{ id: 2, title: "Signal Management" },
				{ id: 3, title: "Switching & Routing" },
				{ id: 4, title: "Switchers" },
				{ id: 5, title: "Signal Procesing" },
				{ id: 6, title: "new Converter" },
				{ id: 7, title: "new Switcher" },
				{ id: 8, title: "new Recorders" },
			],
		},
		{
			id: 11,
			title: "Lighting",
			sub_categories: [
				{ id: 1, title: "Lighting" },
				{ id: 2, title: "Lights Studio" },
			],
		},
		{
			id: 12,
			title: "Control Units",
			sub_categories: [{ id: 1, title: "new Camera Control Units" }],
		},
		{
			id: 13,
			title: "Stands & Mounts",
			sub_categories: [
				{ id: 1, title: "Pedestal" },
				{ id: 2, title: "new Stand" },
			],
		},
		{
			id: 14,
			title: "Rentals",
			sub_categories: [
				{ id: 1, title: "GEARS B-STOCK" },
				{ id: 2, title: "Truck, Trailer, Facilities" },
			],
		},
		{
			id: 15,
			title: "Storage",
			sub_categories: [
				{ id: 1, title: "Servers" },
				{ id: 2, title: "Drives" },
				{ id: 3, title: "Storage Hardware Cloud, Tape & Library" },
			],
		},
		{
			id: 16,
			title: "Digitizing",
			sub_categories: [
				{ id: 1, title: "Motion Picture Film transfer" },
				{ id: 2, title: "Mass Media Migration Services" },
				{ id: 3, title: "Microfiche Digitizing" },
				{ id: 4, title: "Digitize & Archive" },
				{ id: 5, title: "Film - Scanner - Telecine" },
				{ id: 6, title: "Videotape Encoding Services" },
			],
		},
		{
			id: 17,
			title: "Accessories",
			sub_categories: [
				{ id: 1, title: "Cables" },
				{ id: 2, title: "Cases & Bags" },
				{ id: 3, title: "Accessories" },
				{ id: 4, title: "Cables, Accessories" },
			],
		},
		{
			id: 18,
			title: "Power & Batteries",
			sub_categories: [{ id: 1, title: "new Batteries and Power" }],
		},
		{
			id: 19,
			title: "Computers & Software",
			sub_categories: [{ id: 2, title: "Computers & Software" }],
		},
		{
			id: 20,
			title: "Brands",
			sub_categories: [
				{ id: 1, title: "Sony" },
				{ id: 2, title: "Panasonic" },
				{ id: 3, title: "Grass Valley" },
				{ id: 4, title: "Vinten" },
				{ id: 5, title: "Canon" },
				{ id: 6, title: "Blackmagic Design" },
				{ id: 7, title: "Fujinon" },
				{ id: 8, title: "Harris" },
				{ id: 9, title: "JVC" },
				{ id: 10, title: "Snell & Wilcox" },
				{ id: 11, title: "RTI" },
				{ id: 12, title: "Sencore" },
				{ id: 13, title: "EXTRON" },
				{ id: 14, title: "Leitch" },
				{ id: 15, title: "Tektroni" },
				{ id: 16, title: "ALTERAN" },
				{ id: 17, title: "Hitachi" },
				{ id: 18, title: "Philips" },
				{ id: 19, title: "Toshiba" },
				{ id: 20, title: "Vart" },
				{ id: 21, title: "Yamaha" },
			],
		},
	];

	const handleIconClick = (direction) => {
		const tabsBox = tabsBoxRef.current;
		if (!tabsBox) return;
		let newScrollLeft =
			tabsBox.scrollLeft + (direction === "left" ? -340 : 340);
		tabsBox.scrollLeft = newScrollLeft;
		setScrollLeft(newScrollLeft);
	};

	return (
		<>
			<div className="navbar-wrapper">
				<div className="scroll-container">
					<div
						className="scroll-button left"
						onClick={() => handleIconClick("left")}>
						<MdKeyboardArrowLeft
							className="i"
							size={30}
						/>
					</div>
					<ul
						className="tabs-box navbar-tabs-box"
						ref={tabsBoxRef}>
						{subCategoriesData.map((category) => (
							<li
								key={category.id}
								className="navbar-tab">
								<select
									key={category.id}
									defaultValue=""
									onChange={(e) => {
										handleSubCategorySelect(e.target.value);
										e.target.value = "";
									}}
									style={{
										fontSize: "18px",
										cursor: "pointer",
										outline: "none",
										border: "none",
										color: "#fff",
										textTransform: "capitalize",
										appearance: "none",
										backgroundColor: "transparent",
										// Reduced padding to minimize width
										padding: "8px 25px 8px 12px",
										margin: "0",
										minWidth: "auto",
										width: "auto",
										maxWidth: "180px", // Control maximum width
										whiteSpace: "nowrap",
										overflow: "hidden",
										textOverflow: "ellipsis",
										// Custom arrow
										backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e")`,
										backgroundRepeat: "no-repeat",
										backgroundPosition: "right 8px center",
										backgroundSize: "16px",
									}}>
									<option
										value=""
										disabled
										style={{
											// Truncate long titles
											maxWidth: "150px",
											overflow: "hidden",
											textOverflow: "ellipsis",
											whiteSpace: "nowrap",
										}}>
										{/* Truncate title if too long */}
										{category.title.length > 15
											? category.title.substring(0, 15) + "..."
											: category.title}
									</option>
									{category.sub_categories.map((sub) => (
										<option
											key={sub.id}
											value={sub.title}
											style={{
												color: "#333",
												backgroundColor: "#fff",
												textTransform: "capitalize",
												padding: "8px 12px",
											}}>
											{sub.title}
										</option>
									))}
								</select>
							</li>
						))}
					</ul>
					<div
						className="scroll-button right"
						onClick={() => handleIconClick("right")}>
						<MdKeyboardArrowRight
							className="i"
							size={30}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
